/*  Shared Authenticated Users Routes */
export default [
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: {
      name: 'main.routes.dashboard',
      auth: true,
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/Dashboard.vue')
  },
  {
    path: '/user/profile',
    name: 'user-profile',
    meta: {
      name: 'main.routes.profile',
      auth: true,
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/Profile.vue')
  },
  {
    path: '/jobs/my-account',
    name: 'my-account',
    props: true,
    meta: {
      name: 'main.routes.my-account',
      auth: true,
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/Account.vue')
  },

  //Administer Killer Questions Templatess
  // ---------------
  {
    path: '/jobs/admin/killer-questions',
    name: 'manage-killerq-templates',
    meta: {
      name: 'main.routes.killer-questions-templates.main',
      auth: true,
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/killerQuestionsTemplates/KillerQuestionsTemplates.vue')
  },
  {
    path: '/jobs/admin/killer-questions/add-folder',
    name: 'killerq-templates-add-folder',
    meta: {
      name: 'main.routes.killer-questions-templates.add-folder',
      auth: true,
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/killerQuestionsTemplates/AddFolder.vue')
  },
  {
    path: '/jobs/admin/killer-questions/manage-folder',
    name: 'killerq-templates-manage-folder',
    meta: {
      name: 'main.routes.killer-questions-templates.manage-folder',
      auth: true,
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/killerQuestionsTemplates/ManageFolder.vue')
  },
  {
    path: '/jobs/admin/killer-questions/add-question',
    name: 'killerq-templates-add-question',
    meta: {
      name: 'main.routes.killer-questions-templates.add-question',
      auth: true,
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/killerQuestionsTemplates/AddQuestion.vue')
  },
  {
    path: '/jobs/admin/killer-questions/manage-question',
    name: 'killerq-templates-manage-question',
    meta: {
      name: 'main.routes.killer-questions-templates.manage-question',
      auth: true,
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/killerQuestionsTemplates/ManageQuestion.vue')
  },
  // ---------------
]
